import InputType from "@/services/Input/InputType.js";
import Catalog from "../InvoiceCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari " +
      Catalog.SONumber.Label + ", atau " +
      Catalog.ClientID.Label + ", atau " +
      Catalog.PONumber.Label,
    Type: InputType.Text,
    MaxLength: 50
  },
  Date: {
    Label: Catalog.InvoiceDate.Label,
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  },
  WarehouseID: {
    Label: Catalog.WarehouseID.Label,
    Type: InputType.ID,
    Input: InputType.Select
  },
  StatusID: {
    Label: Catalog.Status.Label,
    Type: InputType.Select
  }
}